export default __webpack_public_path__ + "static/insight-c01a6b4878d5852c1828ca0708304f2f.png";